import Base from '../Pages/Base'
import ListCategorias from '../Pages/Categorias/List'
import FormCategorias from '../Pages/Categorias/Form'
import ListConvenios from '../Pages/Convenios/List'
import FormConvenios from '../Pages/Convenios/Form'
import ArquivosList from '../Pages/Arquivos/List'
import FormArquivos from '../Pages/Arquivos/Form'

export default [
	{
		path: 'servicos/convenios',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasConvenios',
				component: ListCategorias,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasConvenios',
				component: FormCategorias,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasEditarConvenios',
				component: FormCategorias,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListConveniosConvenios',
				component: ListConvenios,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormConveniosConvenios',
				component: FormConvenios,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormConveniosEditarConvenios',
				component: FormConvenios,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':cat/:id',
				name: 'ArquivosListConvenios',
				component: ArquivosList,
				props: true,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado-cat',
					}],
					noCache: true
				},
			},

			{
				path: ':cat/:id/novo',
				name: 'FormArquivosConvenios',
				component: FormArquivos,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: '/',
						ref: 'menuSelecionado2'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':cat/:id/editar/:arq',
				name: 'FormArquivosEditarConvenios',
				component: FormArquivos,
				meta: {
					path: '/servicos/convenios',
					pai: 'Serviços',
					title: 'Admin - Convênios - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Convênios',
						class: '',
						active: false,
						url: '/servicos/convenios'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: '/',
						ref: 'menuSelecionado2'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			
		]
	}
]